export const GTM_ID = 'GTM-WMZS86JT';
export const GA_ID = 'G-RHXG9591BP';
